import classNames from 'classnames';
import React from 'react';
import styles from './Container.module.scss';

export type ContainerWidth = 'Slim' | 'Small' | 'Standard' | 'Full width' | '';

export interface ContainerProps {
	width: ContainerWidth;
	children?: React.ReactNode;
	className?: string;
}

export const Container: React.FC<ContainerProps> = ({ width = 'Standard', children, className }) => {
	width = width === '' ? 'Standard' : width;

	return (
		<div
			className={classNames(
				styles.Container,
				{ [styles.Container___standard]: width === 'Standard' },
				{ [styles.Container___narrow]: width === 'Small' },
				{ [styles.Container___slim]: width === 'Slim' }, className,
				"ContainerClass"
			)}
		>
			{children}
		</div>
	);
};